/**
 * Date utilities for handling Firestore Timestamps and ISO strings
 */

/**
 * Convert Firestore Timestamp or ISO string to Date
 * Handles data that comes from either native Firestore SDK (Timestamps)
 * or REST API imports (ISO strings)
 */
export function toDate(value: any): Date | undefined {
  if (!value) return undefined;

  // Handle Firestore Timestamp
  if (value.toDate && typeof value.toDate === 'function') {
    return value.toDate();
  }

  // Handle ISO string
  if (typeof value === 'string') {
    return new Date(value);
  }

  // Handle native Date
  if (value instanceof Date) {
    return value;
  }

  // Handle seconds/nanoseconds format
  if (typeof value === 'object' && value._seconds !== undefined) {
    return new Date(value._seconds * 1000);
  }

  return undefined;
}

/**
 * Convert Date to ISO string (for serialization)
 */
export function toISOString(value: Date | any): string | undefined {
  const date = toDate(value);
  return date ? date.toISOString() : undefined;
}
